import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getMultipleChoiceSingleAnswer = (params) => {
	var url = ApiRouters.MULTIPLECHOICESINGLEANSWER;
	return api.get(url, { params });
};

export const getMultipleChoiceSingleAnswerDetail = (id, params) => {
	var url = `${ApiRouters.MULTIPLECHOICESINGLEANSWER}/${id}`;
	return api.get(url, { params });
};

export const createQuesMultipleChoiceSingleAnswer = (body) => {
	var url = ApiRouters.MULTIPLECHOICESINGLEANSWER;
	return api.post(url, body);
};

export const updateMultipleChoiceSingleAnswerDetail = (body) => {
	var url = `${ApiRouters.MULTIPLECHOICESINGLEANSWER}/${body.get('id')}`;
	return api.put(url, body);
};

export const deleteMultipleChoiceSingleAnswer = (id) => {
	var url = `${ApiRouters.MULTIPLECHOICESINGLEANSWER}/${id}`;
	return api.delete(url);
};
